<template>
  <div class="pixabay-picker-wrapper">
    <transition-group name="zoom" tag="div" class="position-r full-height-width">
      <div v-show="selectedImage !== null" key="cropper" class="position-a full-height-width">
        <cropper
          v-if="selectedImage !== null"
          :img-src="selectedImage"
          :extension="selectedImageExtension"
          ref="cropper">
        </cropper>
      </div>
      <div v-show="selectedImage === null" key="selector" class="position-a full-height-width">
        <div class="pixabay-picker-container">
          <transition :name="transitionName">
            <div class="pixabaysection" v-if="searchView" key="searchView">
              <div class="pixabaybgImg">
                <h2>{{resource.pixbayheader}}</h2>
                <p>{{resource.pixbaysubheader}}</p>
                <el-row type="flex" justify="center">
                  <el-col :span="15">
                    <div class="imagesearch">
                      <el-input
                        :placeholder="resource.imagegalleyplaceholder"
                        @keyup.enter.native="startSearching"
                        v-model="searchInput">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="startSearching"></i>
                      </el-input>
                      <!-- <span class="el-input__icon el-icon-search" @click="startSearching"></span>
                      <input
                        v-model="searchInput"
                        class="el-input__inner"
                        type="text"
                        @keyup.enter="startSearching"
                        :placeholder="resource.imagegalleyplaceholder" /> -->
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="pixabaycategories">
                <p>{{resource.pixbaycategorytext}}</p>
                <el-row type="flex" v-if="resource.pixbaycategories">
                  <el-col :span="6" v-for="(category, position) in categories" :key="position">
                    <ul>
                      <li v-for="(cat, index) in category" :key="index">
                        <a href="javascript:;" @click="handleCategoryClick(cat.value)">{{cat.text}}</a>
                      </li>
                    </ul>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="pixabaysearchresult" v-else key="resultView">
              <div ref="justifiedGalleryWrapper" class="justified-gallery-wrapper">
                <div class="pixabayresult justified-gallery">
                  <template v-for="hit in searchResult.hits">
                    <a href="javascript:void(0);" @click="onImageSelect(hit)">
                      <img :alt="hit.tags" :src="hit.previewURL" />
                    </a>
                  </template>
                </div>
                <infinite-loading @infinite="onInfinite" ref="infiniteLoading">
                  <span slot="no-more">
                    There is no more {{searchInput || selectedCategory}} :(
                </span>
                </infinite-loading>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition-group>
    <el-row type="flex" align="middle" v-show="selectedImage === null">
      <el-col class="poweredby">
        <span>{{resource.powerdby}}</span> <span><img src="../../../assets/pixabay_logo.png" /></span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { chunk } from 'lodash'
import $ from 'jquery'
import InfiniteLoading from 'vue-infinite-loading'
import Cropper from '../Cropper'
import { getExtension } from '@/modules/helper'

export default {
  props: {
    showSave: {
      type: Boolean
    },
    showBack: {
      type: Boolean
    },
    eventBus: {
      type: Object
    }
  },
  data () {
    return {
      searchView: true,
      searchInput: '',
      selectedCategory: '',
      pageNo: 0,
      pageSize: 20,
      searchResult: {
        total: 0,
        totalHits: 0,
        hits: []
      },
      jGallery: null,
      selectedImage: null,
      selectedImageExtension: '',
      scrollPosition: 0
    }
  },
  computed: {
    ...mapGetters([
      'resource'
    ]),
    categories () {
      return chunk(this.resource.pixbaycategories, 5)
    },
    transitionName () {
      return this.searchView ? 'slideDown' : 'slideUp'
    }
  },
  created () {
    this.eventBus.$on('backClick', this.handleBackClick)
    this.eventBus.$on('saveImage', this.handleSaveImageClick)
  },
  beforeDestroy () {
    this.eventBus.$off('backClick', this.handleBackClick)
    this.eventBus.$off('saveImage', this.handleSaveImageClick)
  },
  methods: {
    ...mapActions('imageGallery', [
      'fetchPixabayImages'
    ]),
    handleSaveImageClick () {
      const result = this.$refs.cropper.getResult()
      this.eventBus.$emit('image-selected', result)
      this.selectedImage = null
      this.selectedImageExtension = ''
    },
    getBase64ImageByUrl (url, callback, outputFormat) {
      let img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        let canvas = document.createElement('CANVAS')
        let ctx = canvas.getContext('2d')
        canvas.height = this.height
        canvas.width = this.width
        ctx.drawImage(this, 0, 0)
        callback(canvas.toDataURL(outputFormat))
        canvas = null
      }
      img.src = url
    },
    onImageSelect (hit) {
      this.$showLoader()
      if (this.$refs.justifiedGalleryWrapper) {
        this.scrollPosition = this.$refs.justifiedGalleryWrapper.scrollTop
      }
      this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
      this.selectedImageExtension = getExtension(hit.fullHDURL)
      this.getBase64ImageByUrl(hit.fullHDURL, (data) => {
        this.selectedImage = data
        this.$emit('update:showSave', true)
        this.$hideLoader()
      })
    },
    startSearching () {
      if (this.searchInput) {
        this.selectedCategory = ''
        this.pageNo = 0
        this.searchView = false
        this.$emit('update:showBack', true)
      }
    },
    handleCategoryClick (category) {
      this.selectedCategory = category
      this.searchInput = ''
      this.pageNo = 0
      this.searchView = false
      this.$emit('update:showBack', true)
    },
    handleBackClick () {
      if (this.selectedImage === null) {
        this.searchView = true
        this.$emit('update:showBack', false)
        this.$nextTick(() => {
          this.destroyGallery()
          this.searchInput = ''
          this.selectedCategory = ''
          this.searchResult = {
            total: 0,
            totalHits: 0,
            hits: []
          }
        })
        // setTimeout(() => {
        //   this.destroyGallery()
        //   this.searchInput = ''
        //   this.selectedCategory = ''
        //   this.searchResult = {
        //     total: 0,
        //     totalHits: 0,
        //     hits: []
        //   }
        // }, 1100)
      } else {
        this.selectedImage = null
        this.$emit('update:showSave', false)
        this.jGallery.one('jg.resize', (event) => {
          if (this.$refs.justifiedGalleryWrapper && this.scrollPosition) {
            this.$refs.justifiedGalleryWrapper.scrollTop = this.scrollPosition
          }
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
          }
        })
      }
    },
    initGallery () {
      return new Promise((resolve, reject) => {
        if (this.jGallery) {
          $('.pixabayresult').justifiedGallery('norewind')
          resolve()
        } else {
          this.jGallery = $('.pixabayresult').justifiedGallery({
            rowHeight: 120,
            maxRowHeight: false,
            margins: 3
          })
          this.jGallery.one('jg.complete', (event) => {
            resolve()
          })
        }
      })
    },
    destroyGallery () {
      $('.pixabayresult').justifiedGallery('destroy')
      this.jGallery = null
    },
    async updateResult (response) {
      this.searchResult = {
        total: response.total,
        totalHits: response.totalHits,
        hits: [...this.searchResult.hits, ...response.hits]
      }
      await this.$nextTick()
      await this.initGallery()
    },
    getPixabayAPIPayload () {
      return {
        params: {
          response_group: 'high_resolution',
          q: this.searchInput ? encodeURIComponent(this.searchInput) : '',
          category: this.selectedCategory ? this.selectedCategory : '',
          page: this.pageNo,
          per_page: this.pageSize
        }
      }
    },
    onInfinite ($state) {
      (this.pageNo++)
      this.fetchPixabayImages(this.getPixabayAPIPayload())
        .then((response) => {
          if (!this.searchView) {
            this.updateResult(response.data).then(() => {
              if (this.pageNo * this.pageSize >= response.data.totalHits || response.data.hits.length < this.pageSize) {
                $state.complete()
              } else {
                $state.loaded()
              }
            })
          }
        })
    }
  },
  components: {
    InfiniteLoading,
    Cropper
  }
}
</script>
<style>
.pixabay-picker-wrapper {
  height: 370px;
}
.pixabay-picker-container {
  height: 367px;
  overflow: hidden;
  position: relative;
}
.justified-gallery-wrapper {
  height: 355px;
  overflow-y: auto;
  border-bottom: 5px solid rgb(255, 255, 255);
  box-shadow: 0px 3px 0px #cacaca;
}
.pixabaysection,
.pixabaysearchresult {
  position: absolute;
  width: 100%;
}

.slideUp-enter-active,
.slideUp-leave-active {
  transition: all 1s ease-out;
}

.slideUp-enter {
  transform: translate(0, 100%);
}

.slideUp-leave-to {
  transform: translate(0, -100%);
}

.slideDown-enter-active,
.slideDown-leave-active {
  transition: all 1s ease-out;
}

.slideDown-enter {
  transform: translate(0, -100%);
}

.slideDown-leave-to {
  transform: translate(0, 100%);
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
  to {
    opacity: 0;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
  50% {
    opacity: 1;
  }
}

.zoom-enter-active {
  animation: zoomIn 1.5s;
}

.zoom-leave-active {
  animation: zoomOut 1.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/ImageGallery/Pixabay.vue